module.exports = __webpack_public_path__ + "img/logo-black.d1b15882.svg";